import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import renderAddPaymentEntity from "../../Organisms/Modals/Funding Instruments/select-payment-entity";
import renderSetupStakePay2 from "../../Organisms/Modals/Stake Pay 2/setup-stake-pay-2";
import renderStakeCheckingClosedForNonCompliance from "../../Organisms/Modals/Stake Checking/stake-checking-closed-for-non-compliance";

import { useModalContext } from "../../Contexts/ModalContext";

import {
  getAstraCardsWithSystemCardFiltered,
  isSVDApproved,
  isSVDClosedForStakeSaverNonCompliance,
} from "../../Utils/helpers";


export default function BankingActionButtons({
  stakeDebit = {},
  connectedAccounts = {},
  astraDebitCards = {},
  fromWelcome = false,
}) {
  const navigate = useNavigate();

  const modalContext = useModalContext();

  const isBankAccountConnected = useMemo(() => {
    return connectedAccounts?.data?.data?.accounts?.length > 0;
  }, [connectedAccounts?.data?.data?.accounts]);

  const isAstraAccountConnected = useMemo(() => {
    return getAstraCardsWithSystemCardFiltered(astraDebitCards, stakeDebit).length > 0;
  }, [astraDebitCards, stakeDebit]);

  const IsSVDApproved = useMemo(() => {
    return isSVDApproved(stakeDebit?.data);
  }, [stakeDebit?.data]);

  if (!IsSVDApproved) {
    return <></>;
  }

  const handleOnActionButtonClick = (pathname, transferType) => {
    if (pathname === "add-cash") {
      navigate("/add-cash");
      return;
    }

    if (pathname === "cash-out") {
      navigate("/cash-out");
      return;
    }

    if (!isBankAccountConnected && !isAstraAccountConnected) {
      renderAddPaymentEntity(modalContext, transferType);
    } else {
      navigate(`/${pathname}`);
    }
  };

  const handlePayRentClick = () => {
    if (!isSVDClosedForStakeSaverNonCompliance(stakeDebit?.data)) {
      renderSetupStakePay2(modalContext);
    } else {
      renderStakeCheckingClosedForNonCompliance(modalContext);
    }
  };

  return (
    <div className="quick-actions">
      <button
        className={`qa-btn ${fromWelcome ? "highlight-pulse" : ""}`}
        onClick={handleOnActionButtonClick.bind(this, "add-cash", "add cash")}
      >
        <svg className="qa-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 4V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <span>Add Cash</span>
      </button>
      <button
        className="qa-btn"
        onClick={handleOnActionButtonClick.bind(this, "cash-out", "cash out")}
      >
        <svg className="qa-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 20V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M7 9L12 4L17 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span>Cash Out</span>
      </button>
      <button className="qa-btn" onClick={handlePayRentClick}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 15V7l6-5 6 5v8a1 1 0 01-1 1H4a1 1 0 01-1-1z" stroke="#C0C3D0" strokeWidth="1.4" strokeLinejoin="round" />
          <path d="M7 15v-4h4v4" stroke="#C0C3D0" strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
        <span>Pay Rent</span>
      </button>
    </div>
  );
}
